import { Link, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { PropTypes } from 'prop-types';
import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { getConfigVariable } from '../../common/fn/Config';
import { HELP_PHONE } from '../../common/data/Constants';
import { apiVersion } from '../../common/recoil/atom/APIVersion';
import styles from '../../theme/styles';
import { TermsOfServiceModal } from '../TermsOfService';

const Footer = (props) => {
  const { classes } = props;
  const date = new Date();
  const VERSION = getConfigVariable('VERSION');
  const currentApiVersion = useRecoilValue(apiVersion);
  const funnelName = window.eventFunnel ?? undefined;
  const [tosModalOpen, setTosModalOpen] = useState(false);
  
  const handleOpenTosModal = (e) => {
    e.preventDefault();
    setTosModalOpen(true);
  };
  
  const handleCloseTosModal = () => {
    setTosModalOpen(false);
  };

  return (
    <footer
      role="contentinfo"
      className={classes.footerContainer}
    >
      <div className={classes.footerPrivacyLinksContainer}>
        <hr />
        <Typography
          component="span"
          className={classes.footerPrivacyLinkSpan}
        >
          <a
            href="https://derickdermatology.com/privacy-notice/"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
        </Typography>
        <Typography
          component="span"
          className={classes.footerPrivacyLinkSpan}
        >
          <a
            href="https://derickdermatology.com/DD-NOPP.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Notice of Privacy Practices
          </a>
        </Typography>
        <Typography
          component="span"
          className={classes.footerPrivacyLinkSpan}
        >
          <a
            href="https://derickdermatology.com/wp-content/uploads/2019/06/notice_of_nondiscrimination_6-19-2019.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Notice of Nondiscrimination
          </a>
        </Typography>
        <Typography
          component="span"
          className={classes.footerPrivacyLinkSpan}
        >
          <a
            href="https://derickdermatology.com/sms/"
            target="_blank"
            rel="noreferrer"
          >
            SMS Terms of Service
          </a>
        </Typography>
        <Typography
          component="span"
          className={classes.footerPrivacyLinkSpan}
        >
          <Link
            component="button"
            type="button"
            onClick={handleOpenTosModal}
            className={classes.footerTosLink}
          >
            Terms of Service
          </Link>
        </Typography>
        <Typography
          component="p"
          className={classes.footerHelp}
        >
          Need help? Call{' '}
          <a href={`tel:${HELP_PHONE.tel}`}>{HELP_PHONE.display}</a>
        </Typography>
      </div>
      <div>
        <Typography>&copy; {date.getFullYear()} Derick Dermatology</Typography>
        <Typography>Version v{VERSION}</Typography>
        {currentApiVersion !== 1 && (
          <Typography>API V{currentApiVersion}</Typography>
        )}
        {funnelName && <Typography>Event Funnel: {funnelName}</Typography>}
      </div>
      
      {/* Terms of Service Modal */}
      <TermsOfServiceModal
        open={tosModalOpen}
        onClose={handleCloseTosModal}
      />
    </footer>
  );
};

Footer.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(Footer);
